// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2zf-6","right":"styles_right__187Cs"};